// Contenido de la página /limpieza — texto dictado por la cliente (ES) + versión EN.
export const LIMPIEZA = {
  docTitle: "Páginas web y apps para empresas de limpieza | Cindy Silva",
  description: "Webs y miniapps para empresas de limpieza en EE. UU., de la mano de quien fundó la suya en Naples, Florida. Te atiendo en español.",
  ogTitle: "Páginas web y apps para empresas de limpieza | Cindy Silva",
  ogDescription: "Webs y miniapps para empresas de limpieza en EE. UU., de la mano de quien fundó la suya en Naples, Florida. Te atiendo en español.",
  eyebrow: "Páginas web y miniapps para empresas de limpieza",
  h1a: "Dejas cada casa impecable.",
  h1b: "Que tu web lo demuestre.",
  lead: "Fundé mi propia empresa de limpieza en Naples en 2020. Hoy creo páginas web y miniapps para que la tuya se vea a la altura del trabajo que hace y tus clientes entiendan en segundos por qué elegirte.",
  cta: "Cuéntame de tu empresa",
  story: {
    h: "Yo también empecé limpiando",
    p: "Cuando llegué a Estados Unidos, empecé de cero limpiando apartamentos en el Marriott. Ahí hice mi maestría. Aprendí a limpiar, aprendí a quererlo y, en 2020, con Steve, mi esposo, fundé Cindyrella Cleaning. Si un día falta alguien en el equipo, todavía voy yo a limpiar. Antes de eso tuve quince años de oficio en comunicación en Bolivia. Hoy uno las dos cosas con inteligencia artificial: sé lo que vive una empresa de limpieza y sé cómo contarlo para que tus clientes lo vean.",
  },
  knows: {
    h: "Lo que conozco de cerca",
    items: [
      "Tus mejores clientes llegan por recomendación, pero quien te busca en internet no encuentra nada que te represente.",
      "Cotizar te quita horas, y hacerlo a ojo a veces te hace cobrar de menos.",
      "Cuando no estás en la casa, no sabes cómo quedó, y tu cliente tampoco tiene cómo verlo.",
    ],
  },
  services: {
    h: "Lo que hago para tu empresa",
    cards: [
      { h: "Una página web con identidad", p: "Muestra tu trabajo, lo que ofreces y la zona donde trabajas, en inglés, en español o en los dos idiomas. Con botón de WhatsApp para pedir presupuesto y pensada para verse bien en el celular." },
      { h: "Miniapps a tu medida", p: "Un cotizador para responder rápido y cobrar lo justo, un control de calidad con fotos de antes y después, o la herramienta que tu empresa necesite. Mi recomendación: si estás empezando, empieza por la web. La miniapp llega cuando tu equipo crece y necesitas orden." },
    ],
  },
  built: {
    h: "Lo construí primero para mi empresa",
    projects: [
      { name: "PriceClean Pro", desc: "Un estimador de precios para compañías de limpieza.", status: "Disponible en línea", img: "/priceclean-card.webp", w: 1600, h: 1000, alt: "App PriceClean Pro", url: "https://pricecleanpro.com/", link: "Ver app" },
      { name: "La app de mi equipo", desc: "Mi equipo de Cindyrella registra cada limpieza con fotos de antes y después, y el cliente recibe su reporte.", status: "En uso por mi equipo · Demostración privada", img: "/crew-control-card.webp", w: 1774, h: 887, alt: "App Cindyrella Crew + Control", url: "", link: "" },
    ],
  },
  steps: {
    h: "Tu proyecto empieza contigo",
    items: [
      "Escuchar: me cuentas de tu empresa con un cuestionario corto.",
      "Descubrir: encontramos qué hace distinta a tu empresa.",
      "Diseñar: te muestro cómo se va a ver.",
      "Crear: construyo tu web o tu miniapp.",
      "Revisar: conversamos en cada etapa y, si algo necesita mejorar, volvemos a revisarlo dentro del alcance acordado.",
    ],
  },
  faq: {
    h: "Preguntas frecuentes",
    items: [
      { q: "¿Necesito saber de tecnología o de inteligencia artificial?", a: "No. Tú me cuentas de tu empresa y yo me encargo del resto." },
      { q: "¿Mi web puede estar en inglés si mis clientes son americanos?", a: "Sí. Hablamos en español, y tu web les habla a tus clientes en inglés, o en los dos idiomas." },
      { q: "¿Cuánto cuesta?", a: "Depende de lo que tu empresa necesite. Primero llenas un cuestionario corto, conversamos y te envío una sola propuesta pensada para ti, con la inversión clara." },
      { q: "¿Trabajas solo en Naples?", a: "Estoy en Naples, Florida, y trabajo a distancia con empresas de limpieza de todo Estados Unidos." },
    ],
  },
  form: {
    h: "Tu trabajo es digno y tiene una historia. Que se note.",
    name: "Tu nombre",
    whatsapp: "Tu WhatsApp",
    need: "¿Qué necesitas?",
    needPh: "Una web para mi empresa o un cotizador",
    send: "Enviar por WhatsApp",
    note: "Respondo por escrito en español o inglés.",
    required: "Escribe tu nombre, tu WhatsApp y qué necesitas para continuar.",
    greeting: "Hola Cindy, tengo una empresa de limpieza y quiero información sobre la web.",
  },
  close: "Para quienes hacen de su oficio una obra.",
  waMsg: "Hola Cindy, tengo una empresa de limpieza y quiero información sobre la web.",
};

export const LIMPIEZA_EN = {
  docTitle: "Websites and apps for cleaning companies | Cindy Silva",
  description: "Websites and mini-apps for cleaning companies in the U.S., built by someone who founded her own in Naples, Florida. I answer in English.",
  ogTitle: "Websites and apps for cleaning companies | Cindy Silva",
  ogDescription: "Websites and mini-apps for cleaning companies in the U.S., built by someone who founded her own in Naples, Florida. I answer in English.",
  eyebrow: "Websites and mini-apps for cleaning companies",
  h1a: "You leave every home spotless.",
  h1b: "Let your website prove it.",
  lead: "I founded my own cleaning company in Naples in 2020. Today I build websites and mini-apps so yours looks as good as the work it does — and so your clients understand in seconds why to choose you.",
  cta: "Tell me about your company",
  story: {
    h: "I started out cleaning too",
    p: "When I arrived in the United States, I started from zero cleaning apartments at the Marriott. That was my master's degree. I learned to clean, learned to love it, and in 2020 my husband Steve and I founded Cindyrella Cleaning. If someone on the team is out, I still go and clean myself. Before that, I had fifteen years of craft in communications in Bolivia. Today I bring the two together with artificial intelligence: I know what a cleaning company lives through, and I know how to tell it so your clients see it.",
  },
  knows: {
    h: "What I know up close",
    items: [
      "Your best clients come from word of mouth, but whoever searches for you online finds nothing that represents you.",
      "Quoting eats up your hours, and eyeballing it sometimes makes you charge too little.",
      "When you're not at the house, you don't know how it turned out — and your client has no way to see it either.",
    ],
  },
  services: {
    h: "What I do for your company",
    cards: [
      { h: "A website with identity", p: "Show your work, your services and the area you cover, in English, in Spanish or in both languages. With a WhatsApp button for quotes, and designed to look great on the phone." },
      { h: "Mini-apps made for you", p: "An estimator to answer fast and charge what's fair, a quality-control log with before-and-after photos, or whatever tool your company needs. My advice: if you're just starting out, start with the website. The mini-app comes when your team grows and you need order." },
    ],
  },
  built: {
    h: "I built these first for my company",
    projects: [
      { name: "PriceClean Pro", desc: "A price estimator for cleaning companies.", status: "Available online", img: "/priceclean-card.webp", w: 1600, h: 1000, alt: "PriceClean Pro app", url: "https://pricecleanpro.com/", link: "View app" },
      { name: "My team's app", desc: "My Cindyrella team logs every cleaning with before-and-after photos, and the client receives their report.", status: "In use by my team · Private demonstration", img: "/crew-control-card.webp", w: 1774, h: 887, alt: "Cindyrella Crew + Control app", url: "", link: "" },
    ],
  },
  steps: {
    h: "Your project starts with you",
    items: [
      "Listen: you tell me about your company with a short questionnaire.",
      "Discover: we find what makes your company different.",
      "Design: I show you how it will look.",
      "Create: I build your website or mini-app.",
      "Review: we talk at every stage and, if something needs improving, we revisit it within the agreed scope.",
    ],
  },
  faq: {
    h: "Frequently asked questions",
    items: [
      { q: "Do I need to know about technology or artificial intelligence?", a: "No. You tell me about your company and I take care of the rest." },
      { q: "Can my website be in English for my American clients?", a: "Yes. We talk in Spanish, and your website speaks to your clients in English, or in both languages." },
      { q: "How much does it cost?", a: "It depends on what your company needs. You fill out a short questionnaire first, we talk, and I send you a single proposal made for you, with the investment clear." },
      { q: "Do you only work in Naples?", a: "I'm in Naples, Florida, and I work remotely with cleaning companies across the United States." },
    ],
  },
  form: {
    h: "Your work is dignified and has a story. Let it show.",
    name: "Your name",
    whatsapp: "Your WhatsApp",
    need: "What do you need?",
    needPh: "A website for my company or an estimator",
    send: "Send via WhatsApp",
    note: "I reply in writing, in English or Spanish.",
    required: "Write your name, your WhatsApp and what you need to continue.",
    greeting: "Hi Cindy, I have a cleaning company and I'd like more information about the website.",
  },
  close: "For those who turn their craft into a work of art.",
  waMsg: "Hi Cindy, I have a cleaning company and I'd like more information about the website.",
};
